import React from 'react';

/**
 * DeleteIcon - 휴지통 모양 아이콘
 */
function DeleteIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7748 5.19994C10.4849 5.19994 10.2498 5.43499 10.2498 5.72494V6.17206H13.2165V5.72494C13.2165 5.43499 12.9814 5.19994 12.6915 5.19994H10.7748ZM9.0498 5.72494V6.17206H4.65C4.29101 6.17206 4 6.46307 4 6.82206C4 7.18104 4.29101 7.47206 4.65 7.47206H5.7168V17.5998C5.7168 18.8516 6.73162 19.8664 7.98346 19.8664H15.3446C16.5964 19.8664 17.6112 18.8516 17.6112 17.5998V7.47206H18.8167C19.1757 7.47206 19.4667 7.18104 19.4667 6.82206C19.4667 6.46307 19.1757 6.17206 18.8167 6.17206H14.4165V5.72494C14.4165 4.77225 13.6442 3.99994 12.6915 3.99994H10.7748C9.82211 3.99994 9.0498 4.77225 9.0498 5.72494ZM16.4112 7.47206H6.9168V17.5998C6.9168 18.1889 7.39436 18.6664 7.98346 18.6664H15.3446C15.9337 18.6664 16.4112 18.1889 16.4112 17.5998V7.47206ZM9.83281 10.2664C9.83281 9.93507 9.56418 9.66644 9.23281 9.66644C8.90144 9.66644 8.63281 9.93507 8.63281 10.2664V16.2385C8.63281 16.5699 8.90144 16.8385 9.23281 16.8385C9.56418 16.8385 9.83281 16.5699 9.83281 16.2385V10.2664ZM11.7328 9.66644C12.0642 9.66644 12.3328 9.93507 12.3328 10.2664V16.2385C12.3328 16.5699 12.0642 16.8385 11.7328 16.8385C11.4014 16.8385 11.1328 16.5699 11.1328 16.2385V10.2664C11.1328 9.93507 11.4014 9.66644 11.7328 9.66644ZM14.8328 10.2664C14.8328 9.93507 14.5642 9.66644 14.2328 9.66644C13.9014 9.66644 13.6328 9.93507 13.6328 10.2664V16.2385C13.6328 16.5699 13.9014 16.8385 14.2328 16.8385C14.5642 16.8385 14.8328 16.5699 14.8328 16.2385V10.2664Z"
          fill="#555555"
        />
      </svg>
    </>
  );
}

export default DeleteIcon;
